import { GET_DASHBOARD_ORDER_STATUS } from "./type";

export const initialState = {
  listOrderStatus: [],
};

export function dashboardManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DASHBOARD_ORDER_STATUS:
      return {
        ...state,
        listOrderStatus: action.payload.data
      };
    default:
      return state;
  }
}
